import classNames from "classnames";
import PropTypes from "prop-types";

import React from "react";

export default class Checkbox extends React.Component {
  static displayName = "Checkbox";

  static propTypes = {
    name: PropTypes.string,
    value: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    partial: PropTypes.bool,
    checkboxStyle: PropTypes.object,
    onChange: PropTypes.func,
    children: PropTypes.any,
    defaultChecked: PropTypes.bool,
    label: PropTypes.string.isRequired,
    isRound: PropTypes.bool,
  };

  getIsChecked = () => {
    return this.input.checked;
  };

  handleChange = evnt => {
    return typeof this.props.onChange === "function" ? this.props.onChange(this.getIsChecked(), evnt) : undefined;
  };

  handleClick = e => {
    // Need to stop the event from bubbling for situations
    // when the checkbox has a parent with an onclick (like advancedcombobox)
    if (e != null ? e.stopPropagation : undefined) {
      return e.stopPropagation();
    }
  };

  render() {
    const boxClassName = classNames({
      "et--checkbox--box": true,
      "is-partial": this.props.partial,
    });

    return (
      <label
        className={classNames(this.props.className, "et--checkbox", {
          "is-disabled": this.props.disabled,
          "is-round": this.props.isRound,
        })}
      >
        <input
          ref={e => {
            return (this.input = e);
          }}
          type="checkbox"
          className="et--checkbox--input"
          checked={this.props.checked}
          defaultChecked={this.props.defaultChecked}
          name={this.props.name}
          value={this.props.value}
          disabled={this.props.disabled}
          onClick={this.handleClick}
          onChange={this.handleChange}
        />
        <span
          tabIndex="0"
          role="checkbox"
          aria-checked={this.props.checked}
          aria-label={this.props.label ? `Select ${this.props.label}` : "Select checkbox"}
          onKeyDown={e => {
            if (e.key === "Enter") {
              this.input.click();
            }
          }}
          className={boxClassName}
          style={this.props.checkboxStyle}
        />
        {this.props.children}
      </label>
    );
  }
}
